<template>
  <div class="hear_nav_sty">
    <div class="container">
      <div class="left_logo" @click="$router.push('/home')">
        <!-- <img src="@/assets/images/logo_new.png" alt="" /> -->
      </div>
      <div class="right">
        <el-button
          v-if="!isLogin"
          type="primary"
          round
          @click="$router.push('/login')"
          >登录</el-button
        >
        <div class="right_btns" v-else>
          <!-- <img
            class="icon"
            src="@/assets/images/icons/icon_msg.png"
            alt=""
            @click="$router.push('/message')"
          /> -->
          <el-dropdown trigger="click" @command="handleCommand">
            <el-image
              class="icon"
              style="width: 40px; height: 40px"
              :src="studentInfo ? studentInfo.avatar : ''"
              fit="cover"
            ></el-image>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item icon="el-icon-question" command="setQuestion"
                >设置密保问题</el-dropdown-item
              >
              <el-dropdown-item icon="el-icon-edit" command="editPass"
                >修改密码</el-dropdown-item
              >
              <el-dropdown-item
                icon="el-icon-switch-button"
                :divided="true"
                command="exit"
                >退出</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>

    <el-dialog
      title="修改密码"
      :visible.sync="showEdit"
      :modal="false"
      width="50%"
      center
    >
      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="旧密码" prop="password">
          <el-input
            type="password"
            v-model="ruleForm.password"
            autocomplete="off"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            type="password"
            v-model="ruleForm.newPassword"
            autocomplete="off"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input
            type="password"
            v-model="ruleForm.checkPass"
            autocomplete="off"
            show-password
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetForm('ruleForm')" style="margin-right: 30px"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
          :loading="loading"
          >{{ loading ? "提交中 ..." : "确 定" }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { editPass } from "@/api/user";

export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      loading: false,
      showEdit: false,
      ruleForm: {
        password: "",
        newPassword: "",
        checkPass: "",
      },
      rules: {
        password: { required: true, message: "请输入旧密码", trigger: "blur" },
        newPassword: [
          { required: true, validator: validatePass, trigger: "blur" },
        ],
        checkPass: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.isLogin && this.$store.dispatch("getUserInfo");
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
    studentInfo() {
      return this.$store.state.myInfo;
    },
  },
  methods: {
    handleCommand(command) {
      if (command == "exit") {
        this.$confirm("确定要退出吗?", {
          type: "warning",
        })
          .then(() => {
            this.$router.push("/");
            localStorage.removeItem("Authorization");
            sessionStorage.removeItem("Authorization");
            this.$store.commit("SET_LOGIN", false);
            this.$store.commit("CLEAR_MYINFO");
          })
          .catch(() => {});
      } else if (command == "editPass") {
        this.showEdit = true;
      } else if (command == "setQuestion") {
        this.$router.push("/securityQuestion");
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          editPass({
            password: this.ruleForm.password,
            newPassword: this.ruleForm.newPassword,
          }).then((res) => {
            this.loading = false;
            if (res.code == 0) {
              this.$message.success("修改成功");
              this.resetForm(formName);
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.showEdit = false;
    },
  },
};
</script>

<style lang="less" scoped>
.hear_nav_sty {
  position: fixed;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06);
  height: 66px;
  line-height: 66px;
  background: #fff;
  width: 100%;
  z-index: 9;

  .left_logo {
    float: left;
    cursor: pointer;

    img {
      width: 160px;
      // height: 45px;
    }
  }

  .right {
    float: right;
    .right_btns {
      padding: 13px 0;
      height: 66px;
      .el-dropdown {
        height: 100%;
        .icon {
          border-radius: 50%;
          box-shadow: -2px 2px 6px rgba(83, 83, 83, 0.5);
          cursor: pointer;
        }
      }
    }
  }

  ::v-deep .el-dialog__body {
    padding-left: 90px;
    padding-right: 90px;
  }
}
</style>